import { useState } from "react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";

const ResultColumnTSS = ({
  question,
  setTotalScore,
  questionScores,
  setQuestionScores,
}) => {
  const [grade, setGrade] = useState(
    question.score === null
      ? 0
      : question.score === "-1.00"
      ? "N/A"
      : parseFloat(question.score)
  );

  const [selected, setSelected] = useState(
    question.score === null
      ? 0
      : question.score === "-1.00"
      ? "N/A"
      : Math.round(
          (parseFloat(question.score) / question.weight) * 3
        ).toString()
  );

  return (
    <div className="result">
      <TextField
        className="grade"
        inputProps={{ readOnly: true }}
        value={grade}
      />

      <RadioGroup
        row
        value={selected}
        onChange={(e) => {
          let grade,
            value,
            tempQuestionScores = questionScores;

          if (e.target.value === "N/A") {
            value = "N/A";
            grade = "N/A";
          } else {
            value = Number(e.target.value);
            grade = Math.round((value / 3) * question.weight);
          }

          setSelected(value);
          setGrade(grade);

          tempQuestionScores[
            questionScores.findIndex(
              (questionScore) => questionScore.id === question.scorequestionid
            )
          ].score = grade;

          setTotalScore(
            tempQuestionScores.reduce((accumulator, currentValue) => {
              const score =
                currentValue.score === "N/A" ? 0 : Number(currentValue.score);

              return accumulator + score;
            }, 0)
          );

          setQuestionScores(tempQuestionScores);
        }}
      >
        {question.choice?.split("|").map((option) => (
          <FormControlLabel
            control={<Radio className="radio" />}
            key={option}
            label={option}
            value={option}
          />
        ))}
      </RadioGroup>
    </div>
  );
};

export default ResultColumnTSS;
